<template>
  <a-modal
    v-model="visible"
    :title="title"
    :width="500"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="module-form">
      <a-form-model
        ref="formRef"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="所属系统" prop="plateformId">
              <a-select
                v-model="form.plateformId"
                placeholder="请选择所属系统"
                style="width: 100%"
                :disabled="type === 'edit'"
              >
                <a-select-option v-for="item in systemOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item label="系统名称">
              <a-input v-model="form.plateformName" disabled />
            </a-form-model-item>
          </a-col> -->
        </a-row>

        <a-row>
          <a-col :span="24">
            <a-form-model-item label="模块名称" prop="moduleName">
              <a-input v-model="form.moduleName" placeholder="请输入模块名称" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { listPlateformInfo } from '@/api/news'
import { message } from 'ant-design-vue'

export default {
  name: 'ModuleForm',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add' // 'add' 或 'edit'
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    userInfo: {
      type: Object,
      default: () => ({
        operator: 'sam',
        operatorId: '10001',
        operatorName: '张三'
      })
    }
  },
  data() {
    return {
      form: {
        plateformId: undefined,
        plateformName: '',
        moduleName: ''
      },
      rules: {
        plateformId: [
          { required: true, message: '请选择所属系统', trigger: 'change' }
        ],
        moduleName: [
          { required: true, message: '请输入模块名称', trigger: 'blur' }
        ]
      },
      systemOptions: []
    }
  },
  computed: {
    visible: {
      get() {
        this.loadSystemOptions()
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    title() {
      return this.type === 'add' ? '新增模块' : '编辑模块'
    }
  },
  watch: {
    'form.plateformId'(val) {
      if (val) {
        const selectedSystem = this.systemOptions.find(item => item.value === val)
        this.form.plateformName = selectedSystem ? selectedSystem.label || '' : ''
      } else {
        this.form.plateformName = ''
      }
    },
    value(val) {
      if (val) {
        this.initForm()
      }
    }
  },
  mounted() {
    this.loadSystemOptions()
  },
  methods: {
    async loadSystemOptions() {
      try {
        const res = await listPlateformInfo({})
        this.systemOptions = res.body.map(item => ({
          label: item.plateformName,
          value: item.plateformId
        }))
      } catch (error) {
        message.error('加载系统选项失败')
      }
    },
    initForm() {
      if (this.type === 'edit' && this.editData) {
        this.form = {
          plateformId: this.editData.plateformId,
          plateformName: this.editData.plateformName,
          moduleName: this.editData.moduleName
        }
      } else {
        this.reset()
      }
    },
    async handleOk() {
      try {
        await this.validate()
        const formData = {
          ...this.form,
          ...this.userInfo
        }
        this.$emit('submit', formData)
      } catch (err) {
        // 验证失败不关闭弹窗
        return false
      }
    },
    handleCancel() {
      this.visible = false
      this.reset()
    },
    validate() {
      return this.$refs.formRef.validate()
    },
    reset() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
      this.form = {
        plateformId: undefined,
        plateformName: '',
        moduleName: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.module-form {
  padding: 24px 16px;
}
</style>
